import React from 'react';
import { useTooltip } from '@nivo/tooltip';
import { useReportConfiguration } from 'components/reporting/sidebar/ConfiguredReport';
import ScatterNodeTooltip from './ScatterNodeTooltip';
import { formatDisplayValue } from '../../util';
import styles from '../Chart.module.css';

const BUBBLE_OPACITY = 0.8;

function shouldShowLabel(showLabelConfig, size, percentileNodeSize) {
  if (!showLabelConfig) return false;
  if (showLabelConfig === 'highlights' && size < percentileNodeSize)
    return false;
  return true;
}

function ScatterNode({
  node,
  x,
  y,
  size,
  color,
  onClick,
  openDrawerForDrillIn,
}) {
  const { get } = useReportConfiguration();

  // Add commas for big numbers.
  Object.keys(node.data).forEach(key => {
    node.data[key] = formatDisplayValue(node.data[key]);
  });

  const { showTooltipFromEvent, hideTooltip } = useTooltip();
  const tooltip = <ScatterNodeTooltip data={node.data} color={color} />;

  function handleTooltip(show) {
    if (show) {
      return event => showTooltipFromEvent(tooltip, event);
    } else {
      return () => hideTooltip();
    }
  }

  function handleClick(event) {
    if (typeof openDrawerForDrillIn === 'function') {
      openDrawerForDrillIn(node, event);
    }
    event.preventDefault();
    onClick(node, event);
  }

  const radius = size / 2;
  const labelWidth = 150;
  const showLabel = shouldShowLabel(
    get('showLabels'),
    size,
    get('percentileNodeSize')
  );

  return (
    <g
      onMouseEnter={handleTooltip(true)}
      onMouseMove={handleTooltip(true)}
      onMouseLeave={handleTooltip(false)}
      onClick={handleClick}
      className={styles.ScatterNode}
    >
      <circle cx={x} cy={y} r={radius} fill={color} opacity={BUBBLE_OPACITY} />
      <circle cx={x} cy={y} r={25} fill='transparent' />
      {showLabel && (
        <foreignObject
          x={x - labelWidth / 2}
          y={y + radius + 10}
          width={labelWidth}
          height={35}
        >
          <div
            xmlns='http://www.w3.org/1999/xhtml'
            style={{
              display: '-webkit-box',
              WebkitLineClamp: 1,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textAlign: 'center',
              fontSize: 12,
              color: 'var(--aha-gray-900)',
              userSelect: 'none',
              wordBreak: 'break-all',
              fontWeight: 700,
            }}
          >
            {node.data.label}
          </div>
        </foreignObject>
      )}
    </g>
  );
}

export default ScatterNode;
